import apiClient from "../common/apiClient.js";

export default class MemberGroupController {
    async CreateMemberGroup(formData, token) {
        try {
            return await apiClient.post("/group/memberGroup", formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
        } catch (error) {
            return error;
        }
    }
    // async getMemberGroupList(data, token) {
    //     try {
    //         return await apiClient.post("/group/getMemberGroupList/:id", data, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //                 "Content-Type": "multipart/form-data",
    //             },
    //         });
    //     } catch (error) {
    //         return error;
    //     }
    // }
    async getMemberGroupList(token, userId) {
        try {
            return await apiClient.get("/group/getMemberGroupList/" + userId, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
        } catch (error) {
            return error;
        }
    }
    async getContentDataById(token, id) {
        try {
            return await apiClient.get("/group/getContentDataById/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
        } catch (error) {
            return error;
        }
    }
    async updateMemberGroup(token, id) {
        try {
            return await apiClient.put("/group/updateMemberGroup" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
        } catch (error) {
            return error;
        }
    }
    async deteleMemberGroup(token, id) {

        try {
            return await apiClient.delete("/group/deleteMemberGroup/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
        } catch (error) {
            return error;
        }
    }
    async createPosteAPI(token, formData) {
        try {
            return await apiClient.post("/group/createPoster", formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
        } catch (error) {
            return error;
        }
    }
    async downloadPoster(token, id) {
        // //debugger
        try {
            return await apiClient.get("/group/downloadPoster/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
        } catch (error) {
            return error;
        }
    }
}